import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function TermsOfServicePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* 頁面標題區 */}
      <div className="bg-gradient-to-br from-emerald-50 to-white py-20 mt-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            服務條款
          </h1>
          <p className="text-lg text-gray-600">
            朋睿國際策略管理顧問股份有限公司網站服務條款
          </p>
        </div>
      </div>

      {/* 文章內容區 */}
      <div className="max-w-[900px] mx-auto px-6 lg:px-8 py-16">
        <article className="prose prose-lg max-w-none">
          <div className="space-y-8 text-gray-700 leading-relaxed" style={{ lineHeight: '1.6' }}>
            
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">服務條款</h2>
              <p className="mb-5 text-gray-600">
                最後更新日期：2026 年 2 月 23 日
              </p>
              <p className="mb-5">
                歡迎蒞臨「朋睿國際策略管理顧問股份有限公司網站」（以下簡稱「本網站」或「本公司」）。為了保障使用者權益並維護網站服務品質，本條款規範您使用本網站及相關延伸服務時的權利與義務。使用本網站即表示您已閱讀、理解並同意遵守本條款。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">服務內容</h2>
              <p className="mb-5">
                本網站提供有關策略管理顧問服務、專案資訊、課程活動報名、專業資訊分享及會員專屬功能。網站內容僅供一般資訊參考，並非個別投資、法律或財務建議。使用者應依自身需求判斷資訊適用性。
              </p>
              <p className="mb-5">
                本公司保留隨時新增、修改、暫停或終止部分網站功能及服務的權利，並不需另行通知。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">使用者義務</h2>
              <p className="mb-5">
                若使用者需註冊會員或使用帳號功能，應提供正確、完整及最新的個人資料。使用者應妥善保管相關資訊，避免提供給他人使用。任何經帳號登入所進行的行為均視為使用者本人操作，使用者須自行負責。
              </p>
              <p className="mb-5">
                使用者不得利用本網站從事任何非法、侵權或損害本公司或第三方權益之行為，包括但不限於：
              </p>
              <ul className="list-disc pl-6 mb-5 space-y-2">
                <li>未經授權存取網站資料或系統</li>
                <li>散布惡意軟體、病毒或其他破壞系統安全的程式</li>
                <li>偽造或冒用他人身分</li>
                <li>發布誹謗、猥褻、威脅或其他不當內容</li>
              </ul>
              <p className="mb-5">
                違反上述規定，本公司保留暫停或終止使用權利，並依法追究相關責任。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">知識產權</h2>
              <p className="mb-5">
                本網站所載所有文字、圖片、商標、標誌、影音及程式碼等內容，均屬本公司或相關權利人所有，受著作權及其他智慧財產權保護。未經本公司書面同意，使用者不得以任何形式擅自重製、散布、修改或公開傳輸上述內容。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">免責聲明</h2>
              <p className="mb-5">
                本網站內容僅供參考，本公司不保證其完整性、正確性、即時性或適用性。對於使用者因使用本網站內容所產生之任何直接或間接損失，本公司不承擔任何法律責任。
              </p>
              <p className="mb-5">
                本網站可能包含指向第三方網站的連結，僅為方便使用者，對該等第三方網站之內容及隱私保護，本公司不負責。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">個人資料保護</h2>
              <p className="mb-5">
                使用者之個人資料蒐集、處理與利用，依據本公司「隱私權政策」辦理。使用本網站即表示您同意本公司依隱私權政策使用個人資料。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">法律適用與管轄</h2>
              <p className="mb-5">
                本條款之解釋、效力及履行，均適用中華民國相關法律。若發生爭議，雙方同意以本公司所在地之地方法院為第一審管轄法院。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">條款修訂</h2>
              <p className="mb-5">
                本公司保留隨時修訂本條款之權利，修訂後條款將公布於本網站，並自公告日起生效。使用者持續使用本網站，即表示同意接受更新後條款之約束。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">聯絡方式</h2>
              <p className="mb-5">
                若對本條款有任何疑問，請透過以下方式與我們聯絡：
              </p>
              <p className="mb-5">
                電子郵件：<br />
                <a href="mailto:contact@psfcapital.tw" className="text-emerald-600 hover:text-emerald-700 cursor-pointer">contact@psfcapital.tw</a>
              </p>
            </section>

          </div>
        </article>
      </div>

      <Footer />
    </div>
  );
}